import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TripReplayRoutingModule } from './trip-replay-routing.module';
import { TripReplayComponent } from './components/trip-replay/trip-replay.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { SideBarTripReplayComponent } from './components/side-bar-tr/side-bar-tr.component';
import { EventTabComponent } from './components/event-tab/event-tab.component';
import { TripTabComponent } from './components/trip-tab/trip-tab.component';
import { TripPlayerComponent } from './components/trip-player/trip-player.component';
import { LoaderModule } from 'mis-crystal-design-system/loader';
import { TripViewModule } from '../trip-view/trip-view.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TripViewCabModule } from '../trip-view-cab/trip-view-cab.module';
import { EmployeeListComponent } from './components/employee-list/employee-list.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    TripReplayComponent,
    MapViewComponent,
    SideBarTripReplayComponent,
    EventTabComponent,
    TripTabComponent,
    TripPlayerComponent,
    EmployeeListComponent
  ],
  imports: [
    LoaderModule,
    CommonModule,
    BrowserAnimationsModule,
    TripReplayRoutingModule,
    TripViewModule,
    TripViewCabModule,
    ReactiveFormsModule
  ],
  exports: [
    TripReplayComponent,
    SideBarTripReplayComponent,
    EventTabComponent,
    TripTabComponent,
    TripPlayerComponent,
    EmployeeListComponent
  ],
})
export class TripReplayModule {}
